import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/life-ring': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM152.6 427.3c63.2 38.3 143.6 38.3 206.8 0l-53.4-53.4c-31.8 13.5-68.2 13.5-100 0zM336 256c0-44.1-35.9-80-80-80s-80 35.9-80 80 35.9 80 80 80 80-35.9 80-80zM427.3 359.4c38.3-63.2 38.3-143.6 0-206.8l-53.4 53.4c13.5 31.8 13.5 68.2 0 100zM359.4 84.7c-63.2-38.3-143.6-38.3-206.8 0l53.4 53.4c31.8-13.5 68.2-13.5 100 0zM84.7 152.6c-38.3 63.2-38.3 143.6 0 206.8l53.4-53.4c-13.5-31.8-13.5-68.2 0-100z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/life-ring.js
// module id = 1792
// module chunks = 0